import BaseModel from '@/shared/models/Rule'

export default class Rule extends BaseModel {}
